enum WalletErrorCodes {
  // Reward Wallet
  RWInsufficientBalance = "PBERRREWWALInsufficientBalance",
  RWHumanInterventionRequired = "PBERRREWWALHumanInterventionRequired",
  RWMultiError = "PBERRREWWALMultiError",
  RWBadRequest = "PBERRREWWALBadRequest",
  RWUnsupportedMediaType = "PBERRREWWALUnsupportedMediaType",
  RWTooLong = "PBERRREWWALTooLong",
  RWTooLarge = "PBERRREWWALTooLarge",
  RWTooSmall = "PBERRREWWALTooSmall",
  RWInvalidUnsignedInteger = "PBERRREWWALInvalidUnsignedInteger",
  RWInvalidCurrencyCode = "PBERRREWWALInvalidCurrencyCode",
  RWInvalidUUID = "PBERRREWWALInvalidUUID",
  RWInvalid = "PBERRREWWALInvalid",
  RWNotUnique = "PBERRREWWALNotUnique",
  RWNotFound = "PBERRREWWALNotFound",
  RWRequired = "PBERRREWWALRequired",
  RWForbidden = "PBERRREWWALForbidden",

  // Tenant Wallet
  TWAlreadyExists = "PBTWAlreadyExists",
  TWDBPing = "PBTWDBPing",
  TWHumanInterventionRequired = "PBTWHumanInterventionRequired",
  TWInvalidArguments = "PBTWInvalidArguments",
  TWNotFound = "PBTWNotFound",
  TWUnauthorized = "PBTWUnauthorized",
  TWForbidden = "PBTWForbidden",
  TWUnknown = "PBTWUnknown"
}

export default WalletErrorCodes